import { useState, type ReactNode } from 'react'
import { AppProviders } from './AppProviders'
import { useRouterEvent } from '../hooks/useRouterEvent'

// Inertia 遷移時の page component 名を state 化し、AppProviders に流して
// theme/colorScheme を都度切り替える。
//
// 本コンポーネントを entrypoint (inertia.tsx) に置くと @vitejs/plugin-react が
// React refresh boundary 用に末尾自己 import (?t=<ts>) を仕込み、createInertiaApp と
// createRoot が二重評価される (= router listener 累積 → flash トースト二重発火) ため、
// entrypoint からは「コンポーネント export を含む」要素を分離する目的で別ファイルにしている。
export function ThemedRoot({
  initialComponent,
  children,
}: {
  initialComponent: string
  children: ReactNode
}) {
  const [component, setComponent] = useState(initialComponent)

  // トップページの scroll-behavior: smooth (utilities.css) には Inertia の遷移時スクロール
  // リセット (window.scrollTo(0, 0)) も乗ってしまい、離脱先のページが上へ滑って見える。
  // 遷移の間だけ smooth を打ち消す (Inertia は scroll reset → navigate の順で走るので、
  // navigate で解除すればリセットは瞬時になる)。
  useRouterEvent('start', () => {
    document.documentElement.setAttribute('data-scroll-behavior', 'auto')
  })

  useRouterEvent('navigate', (event) => {
    document.documentElement.removeAttribute('data-scroll-behavior')
    setComponent(event.detail.page.component)
  })

  return <AppProviders component={component}>{children}</AppProviders>
}
